export default __webpack_public_path__ + "static/media/comma.300071eb.svg";